const createState = () => ({
  error: null,
  offline: false,
  embed: false,
  debugMode: false,
  testMode: false,
  previewMode: false,
  npsMode: 'default'
});

export default createState;
